import styled from '@emotion/styled';

import { Avatar, tokens } from '@hotjar/hotsauce';

const getBackground = ({ highlight }: { highlight: boolean }) =>
  highlight ? tokens.color.neutral_100 : 'transparent';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${getBackground};
  padding: ${tokens.spacer.x1} ${tokens.spacer.x2};
  text-align: left;
`;

const TextWrapper = styled.div`
  margin-left: ${tokens.spacer.x1};
`;

const Name = styled.div`
  color: ${tokens.color.text_default};
  font-size: 12px;
  line-height: 1.4;
  font-weight: bold;
`;

const Email = styled.div`
  color: ${tokens.color.text_default};
  font-size: 12px;
  line-height: 1.4;
`;

const StyledAvatar = styled(Avatar)`
  flex-shrink: 0;
`;

interface ListUserCardProps {
  name: string;
  email: string | null;
  avatar: string | null;
  focused: boolean;
  className?: string;
  onSelect?: () => void;
}

export const ListUserCard = ({
  className,
  name,
  avatar,
  email,
  focused,
  onSelect,
}: ListUserCardProps): JSX.Element => {
  return (
    <Wrapper highlight={focused} className={className} onClick={onSelect}>
      <StyledAvatar userName={name} src={avatar === null ? undefined : avatar} size="l" />
      <TextWrapper>
        <Name>{name}</Name>
        <Email>{email}</Email>
      </TextWrapper>
    </Wrapper>
  );
};
